import React, {Component} from 'react';
import ReactLoading from 'react-loading';

import Header from '../Header/Header';
import StatsDataGridContainer from "../../containers/DataGrid/StatsDataGridContainer";
import './Stats.css';

class Stats extends Component {

    constructor(props) {
        super(props);
        this.state = {loading: true};
        this.renderStats = this.renderStats.bind(this);
    }

    componentDidMount() {
        this.setState({loading: false});
        this.props.fetchStatsColumns();
        this.props.fetchStats();
    }   

    transformStats(stats){
        console.log("stats is ", stats);
        if(Array.isArray(stats)){
            return stats.map( (stat, index) => {
                return {
                    fileId: stat.file_id,
                    fileName: stat.file_name,
                    fileCreateDt: stat.file_create_dt,
                    inputLineCount: stat.input_line_count,
                    processDt: stat.process_dt,
                    outputLineCount: stat.output_line_count
                };
            });
        } else {
            return [];
        }
    }

    renderStats() {
        if(this.props.stats && this.props.stats.length > 0) {
        return (
            <div>
                <StatsDataGridContainer 
                    statsColumns={this.props.statsColumns} 
                    data={this.transformStats(this.props.stats)}
                />
            </div>
            );
        } else if(this.props.statsLoading) {
            return (
                <div className="loader">
                    <ReactLoading type={"spin"} color={"#666666"} height={'15%'} width={'15%'}/>
                </div>
            )
        } else {
            return (
                <h4>No statistics available.</h4>
            );
        }
    }

    render() {
        return (
            <div id="stats"> 
                <Header title="File Processing Statistics" />
                {this.renderStats()}
            </div>
        );
    }
      
}

export default Stats;



// WEBPACK FOOTER //
// ./src/components/Stats/Stats.js